<template>
	<div class="home">
        <!-- 模块列表 -->
        <div class="home-content">
            <template v-for="(item, index) in xitoList">
            	<div 
            		:id="item.id"
            		:key="item.id"
            		:type="item.type"
            		:index="index"
            		:typeData="item"
					:chatVid="chatVid"
                    :themeColor="themeColor"
            		:is="componentConfig[item.type]" 
            		v-if="componentConfig[item.type]"
            		:class="item.type | setModuleClass">
            	</div>
            </template>
        </div>
        <!-- 返回顶部 -->
        <span class="go-back-top">Top</span>
    </div>
</template>

<script>
    // 模块组件列表
	import Vconsole from 'vconsole'
	// const vConsole = new Vconsole()
	import socket from 'util/socket.js'
	import watermark from 'watermark-dom'
	import scrollReveal from 'scrollreveal'
	import component from './module/index.js'
	import iframeConnect from 'util/iframeConnect.js'
    import { timeout, throttle } from 'util/timeout.js'
    import { dataHandler, phamulaHandler } from 'util/phamulaHandler.js'
	import { isObjectBound, judgeVariousData, getPhamulaDetail } from 'util/getPhamula.js'
	export default {
		name: 'home',
		data() {
			return {
				chatVid: '',
                xitoList: [],
                blockList: [],
				themeColor: '#41466E',
                scrollSocket: null,
				scrollReveal: scrollReveal()
            }
		},
		watch: {
            '$route'(newValue) {
                window.location.reload();
            }
		},
        mounted() {
			// https://pageview.xitohere.com
			// console.clear()
			console.log(this.$config)
			this.closeScrollSocket();
			// 如果是iframe模式
			if (this.isIframe) {
            	console.log('%c 子页面初始化完成', 'color: green')
				if (document.body.classList.contains('iframe-body') === false) {
					document.body.classList.add('iframe-body');
				}
				const config = {
					role: 'child',
					debug: true,
					target: window,
					whiteList: process.env.NODE_ENV === 'development' ? '*' : [
					    'http://localhost:8080',
					    'http://localhost:8081',
					    'http://localhost:8082',
					    'http://localhost:8083',
					    'https://app.vauther.com',
						'http://app.vauther.com',
					    'https://vk.xitohere.com',
					    'https://lisheng.xitohere.com',
					    'https://contents.expo-museum.com',
					    'https://varyon.xitotech.com',
					    'http://vk.xitohere.com',
					    'http://lisheng.xitohere.com',
					    'http://contents.expo-museum.com',
					    'http://varyon.xitotech.com'
					]
				};
				const onEvent = this.receiveMessage.bind(this);
				// 建立与父页面通信
				iframeConnect.init(config, onEvent);
				// 页面加载完毕，发送初始化完成信号
				this.sendMessage('INIT_END');
			}
			// 普通拉取数据显示模式
			else {
				this.blockList = [];
				this.xitoList = [];
				this.getData();
			}
			// 开启打印模式
			if ('debug' in this.$config.QUERY) {
				new Vconsole();
			}
			// 微信小程序端未引入支付js链接
			if ('notPay' in this.$config.QUERY) {} else {
				this.loadStripe();
			}
        },
		methods: {
			loadStripe() {
			    const head = document.getElementsByTagName('head')[0];
			    if (document.getElementById('stripe_js')) {} else {
			        const script = document.createElement('script');
			        const src = 'https://js.stripe.com/v3/';
			        script.type = 'text/javascript';
			        script.id = 'stripe_js';
			        script.src = src;
			        head.appendChild(script);
			    } 
			},
			loadGoogleAnalytics(googleId) {
				if (!googleId || googleId.trim() === '') return;
				
				// Remove existing Google Analytics scripts if any
				const existingScripts = document.querySelectorAll('script[src*="googletagmanager.com"]');
				existingScripts.forEach(script => script.remove());
				
				// Load gtag.js script
				const gtagScript = document.createElement('script');
				gtagScript.async = true;
				gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${googleId}`;
				document.head.appendChild(gtagScript);
				
				// Initialize Google Analytics
				gtagScript.onload = () => {
					window.dataLayer = window.dataLayer || [];
					function gtag(){dataLayer.push(arguments);}
					gtag('js', new Date());
					gtag('config', googleId);
					
					// Make gtag globally available
					window.gtag = gtag;
				};
			},
			sendMessage(type = '', data = null) {
				if (type) {
					// INIT_END 			页面加载完成 => 显示场景
					data ? iframeConnect.sendMessage(type, data) : iframeConnect.sendMessage(type);
				}
			},
            receiveMessage({ type, data }) {
				switch(type) {
                	case 'PAGE_LOADED':
                		// 页面加载完毕，发送初始化完成信号
                        this.sendMessage('INIT_END');
                        // 关闭加载动画
                        this.$loading('', false);
                		break;
                	case 'DATA_UPDATE':
                        // 将接收隐私弹窗每次设置为false
                        this.$userInfo.setData({ accept: false });
                		// 数据更新
						this.xitoList = phamulaHandler(this.dataReorder(data || []), 0, true);
                		break;
                	case 'SET_LANGUAGE':
                		// 设置多语言
                        // this.$store.commit('modifyLanguage', data);
                		break;
                }
            },
            async getData() {
                //console.clear()
				// 如果存在code就去显示水印和打卡
				if (this.$config.QUERY['code']) {
					const codeResult = await this.$http.uniqueview.get_id_from_randvid(this.$config.QUERY['code']);
					console.log('code', JSON.parse(JSON.stringify(codeResult)))
					if (codeResult.status === 'success') {
						const timestamp = Date.parse(new Date()) / 1000;;
						const { id, notes, tpo_id: object_id, is_watermark, creator_user_id } = codeResult.data;
						// 是否要生成水印
						if (is_watermark) {
							const watermarkData = {
								watermark_txt: '',					//水印的内容
								watermark_x: 10,                    //水印起始位置x轴坐标
								watermark_y: 10,                    //水印起始位置Y轴坐标
								watermark_angle: 45,                //水印倾斜度数
								watermark_alpha: 0.5,               //水印透明度，要求设置在大于等于0.005
								watermark_color: 'grey',            //水印字体颜色
								watermark_width: 150,               //水印宽度
								watermark_height: 80,               //水印长度
								watermark_x_space: 20,              //水印x轴间隔
								watermark_y_space: 60,              //水印y轴间隔
								watermark_fontsize: '18px',         //水印字体大小
								// watermark_id: 'wm_div_id',          //水印总体的id
								// watermark_prefix: 'mask_div_id',    //小水印的id前缀
								// watermark_rows:0,                   //水印行数
								// watermark_cols:0,                   //水印列数
								// watermark_font:'微软雅黑',           //水印字体
								// watermark_parent_width:0,      //水印的总体宽度（默认值：body的scrollWidth和clientWidth的较大值）
								// watermark_parent_height:0,     //水印的总体高度（默认值：body的scrollHeight和clientHeight的较大值）
								// watermark_parent_node:null     //水印插件挂载的父元素element,不输入则默认挂在body上
							};
							// 我方水印
							if (is_watermark === 1) {
								// 获取创建者信息生成水印
								const userResult = await this.$http.user.public_profile(creator_user_id);
								if (userResult.status === 'success') {
									userResult.data.name && (watermarkData.watermark_txt += userResult.data.name);
									userResult.data.mobile && (watermarkData.watermark_txt += (watermarkData.watermark_txt ? ' ' : '') + userResult.data.mobile);
								}
							}
							// 对方水印
							if (is_watermark === 2) {
								if (notes.name || notes.phone) {
									notes.name && (watermarkData.watermark_txt += notes.name);
									notes.phone && (watermarkData.watermark_txt += (watermarkData.watermark_txt ? ' ' : '') + notes.phone);
								}
							}
							// 创建水印
							if (watermarkData.watermark_txt) {
								watermark.init(watermarkData);
							}
						}
						// 去打卡(最重要)
						await this.$http.user.punch_daka({
							daka_type_l1: '30',
							daka_type_l2: id,
							value: '1',
							length: '1',
							timestamp,
							object_id,
							notes: ''
						});
					}
				}
                let jsonData = null,
					fromFile = false;
				// Get HOSTNAME from config
				const hostname = this.$config.HOSTNAME;
				// Initialize hostname_send
				let hostname_send = hostname;
				// Check if hostname starts with "pager"
				if (hostname && hostname.startsWith('pager')) {
					hostname_send = '';
				}else{
					hostname_send = hostname;
				}

				// 如果存在文件数据
				if (this.$config['content']) {
					jsonData = this.$config['content'];
					fromFile = true;
				}
				
				
				// 如果存在phamula_id
				else if (this.$config['libraryId']) {
					console.log(this.$config['region'])
					console.log(this.$config['API'])
					console.log('youlaile',hostname_send)
					const result = await this.$http.phamula.detail(this.$config['libraryId'], hostname_send);
					
					if (result.status === 'success' && result.data) {
						jsonData = result.data;
						fromFile = false;
					}
				// Update the website title
				if (jsonData && jsonData.name) {
					document.title = jsonData.name;

				}

				// Update the website favicon
				// if (jsonData && jsonData.obj_photo) {
				// 	const link = document.querySelector("link[rel~='icon']");
				// 	if (link) {
				// 		link.href = jsonData.obj_photo;
				// 	} else {
				// 		const newLink = document.createElement('link');
				// 		newLink.rel = 'icon';
				// 		newLink.href = jsonData.obj_photo;
				// 		document.head.appendChild(newLink);
				// 	}
				// }
				// // 更新网站 favicon（改进版）
				// if (jsonData && jsonData.obj_photo) {
				// 	this.updateFavicon(jsonData.obj_photo);
				// }
				}
				else{

				
				console.log('HOSTNAME:', hostname);
				if (hostname) {
					//jsonData = this.$config['content']
					const page_tag = this.$config['route'];
					const result = await this.$http.phamula.host_detail(hostname_send, page_tag);
					if (result.status === 'success' && result.data) {




						jsonData = result.data;
						fromFile = false;
						// Update the website title
						document.title = jsonData.name;
                        
                        // 更新 favicon
                        this.updateFavicon(jsonData.obj_photo);
                    
						}
					}
				}



				console.log('phamula', JSON.parse(JSON.stringify(jsonData)))
				
				// const a = JSON.parse(JSON.stringify(jsonData));
				// const b = Object.create(null);
				// b.jsonStr = Object.create(null);
				// b.name = a.obj_relation_json.name;
				// b.type = a.obj_relation_json.type;
				// b.jsonStr.su = [];
				// b.jsonStr.rt = a.obj_relation_json.jsonStr.rt;
				// b.jsonStr.edd = a.obj_relation_json.jsonStr.edd;
				// for (let { su, rt, edd } of a.obj_relation_json.jsonStr.su) {
				// 	let c = Object.create(null);
				// 	c.su = [];
				// 	c.rt = rt;
				// 	c.edd = edd;
				// 	for (let { ed, tg } of su) {
				// 		let d = Object.create(null);
				// 		d.ed = ed;
				// 		d.tg = tg;
				// 		c.su.push(d);
				// 	}
				// 	b.jsonStr.su.push(c);
				// }
				// console.log(b)
				// console.log(JSON.stringify(b))
				
				if (judgeVariousData(jsonData, 'phamula_type', 6) && judgeVariousData(jsonData, 'phamula_tree')) {
					// 初始化重排显示顺序
					jsonData.obj_relation_json.jsonStr.su = this.dataReorder(jsonData.obj_relation_json.jsonStr.su || []);
				} else {
					this.loadDataError();
					return;
				}
				if (fromFile === false) {
					// 显示加载动画
					// this.$loading('正在加载数据中', true);
					this.$loading('', true);
				}
				this.chatVid = jsonData.vid;

				// Extract and load Google Analytics ID
				if (jsonData.vid && jsonData.vid.includes(',')) {
					const [googleId, chatId] = jsonData.vid.split(',').map(id => id.trim());
					if (googleId && googleId.startsWith('G-')) {
						this.loadGoogleAnalytics(googleId);
					}
					// Update chatVid to only contain the chat ID part
					this.chatVid = chatId || '';
				} else if (jsonData.vid && jsonData.vid.startsWith('G-')) {
					// If vid only contains Google Analytics ID
					this.loadGoogleAnalytics(jsonData.vid);
					this.chatVid = '';
				}

				
				// // 添加客服弹窗
				// jsonData.obj_relation_json.jsonStr.su.indexOf(item => item.edd === 'typeTalk') === -1 && jsonData.obj_relation_json.jsonStr.su.push({
				// 	su: [],
				// 	rt: '1',
				// 	edd: 'typeTalk'
				// });
				
				jsonData = await getPhamulaDetail(jsonData, (data, showList, status, speed, total, layer, index, parentIndex) => {
					if (status === 'before') {
						let object_id = layer === 2 ? '' : isObjectBound(data) ? '' : data['ed'];
						let fromLocal = true;
						let bindDataKey = 'phamula,object,tuwen';
						return {
							object_id,
							fromLocal,
							bindDataKey
						};
					}
					if (status === 'after') {
						if (layer === 2) {
							this.xitoList.push(phamulaHandler({ ...data, su: [] }, index, true));
							if (fromFile === false) {
								this.$loading('', false);
							}
						}
						if (layer === 3) {
							if (this.xitoList[parentIndex]) {
								this.xitoList[parentIndex].raw_data.su.push(data);
								this.$set(this.xitoList, parentIndex, phamulaHandler(this.xitoList[parentIndex].raw_data, parentIndex));
							}
						}
					}
				});
				// 加载头部、尾部、客服框、常见问题的phamula数据
				for (let i = 0, length = this.xitoList.length; i < length; i++) {
					// if (['typeHeader', 'typeFooter', 'typeTalk', 'typeO'].indexOf(this.xitoList[i].type) > -1) {
					if (['typeHeader', 'typeFooter'].indexOf(this.xitoList[i].type) > -1) {
						if (this.xitoList[i].raw_data.su[0] && this.xitoList[i].raw_data.su[0]._phamula_data) {
							let typePhamula = this.xitoList[i].raw_data.su[0]._phamula_data;
							this.xitoList[i].raw_data.su = this.xitoList[i].raw_data.su.slice(0, 1);
							this.xitoList[i].raw_data.su[0]._phamula_data = await getPhamulaDetail(typePhamula, (data, showList, status) => {
								if (status === 'before') {
									return {
										object_id: isObjectBound(data) ? '' : (data['ed'] || data['edd']),
										fromLocal: true,
										bindDataKey: 'object'
									};
								}
							});
							this.$set(this.xitoList, i, phamulaHandler(this.xitoList[i].raw_data, i));
						}
					}
				}
				// 关闭动画，显示特效
				this.loadDataSuccess(jsonData);
				
				console.log(this.componentConfig)
            },

			tryHostnameIco(fallbackUrl) {
				const hostname = this.$config.HOSTNAME;
				if (hostname) {
					const icoUrl = `/${hostname}.ico`;
					
					// 创建一个图片对象来测试 ICO 文件是否存在
					const testImg = new Image();
					testImg.onload = () => {
						// ICO 文件存在，使用它
						this.setFaviconDirect(icoUrl);
					};
					testImg.onerror = () => {
						// ICO 文件不存在，使用原图片
						this.convertAndSetFavicon(fallbackUrl);
					};
					testImg.src = icoUrl;
				} else {
					this.convertAndSetFavicon(fallbackUrl);
				}
			},

        // Favicon 更新方法（改进版）
        updateFavicon(imageUrl) {
            if (!imageUrl) return;
            
            // 方法1: 直接使用图片URL（现代浏览器支持）
            this.setFaviconDirect(imageUrl);
            
            // 方法2: 转换为ICO格式（备用方案）
            this.convertToIco(imageUrl);
        },

        // 直接设置 favicon
        setFaviconDirect(imageUrl) {
            try {
                // 移除现有的 favicon
                const existingLinks = document.querySelectorAll("link[rel*='icon']");
                existingLinks.forEach(link => {
                    if (link.parentNode) {
                        link.parentNode.removeChild(link);
                    }
                });

                // 添加新的 favicon
                const link = document.createElement('link');
                link.rel = 'icon';
                link.type = 'image/png'; // 或根据文件类型动态设置
                link.href = imageUrl + '?t=' + Date.now(); // 添加时间戳避免缓存
                document.head.appendChild(link);

                // 同时添加 shortcut icon（兼容性）
                const shortcutLink = document.createElement('link');
                shortcutLink.rel = 'shortcut icon';
                shortcutLink.href = imageUrl + '?t=' + Date.now();
                document.head.appendChild(shortcutLink);

            } catch (error) {
                console.error('设置 favicon 失败:', error);
            }
        },

        // 将图片转换为 ICO 格式（浏览器端）
        convertToIco(imageUrl) {
            const img = new Image();
            img.crossOrigin = 'anonymous'; // 处理跨域问题
            
            img.onload = () => {
                try {
                    // 创建 canvas
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // 设置 favicon 标准尺寸
                    canvas.width = 32;
                    canvas.height = 32;
                    
                    // 绘制图片到 canvas
                    ctx.drawImage(img, 0, 0, 32, 32);
                    
                    // 转换为 data URL
                    const dataURL = canvas.toDataURL('image/png');
                    
                    // 设置为 favicon
                    const link = document.createElement('link');
                    link.rel = 'icon';
                    link.type = 'image/png';
                    link.href = dataURL;
                    document.head.appendChild(link);
                    
                } catch (error) {
                    console.error('转换图片为 favicon 失败:', error);
                    // 降级到直接使用原图片
                    this.setFaviconDirect(imageUrl);
                }
            };
            
            img.onerror = () => {
                console.error('加载图片失败:', imageUrl);
            };
            
            img.src = imageUrl;
        },

        // 检查主机名对应的 ICO 文件（备用方案）
        checkHostnameIco() {
            const hostname = this.$config.HOSTNAME;
            if (hostname) {
                const icoUrl = `/${hostname}.ico`;
                
                // 检查文件是否存在
                const img = new Image();
                img.onload = () => {
                    this.setFaviconDirect(icoUrl);
                };
                img.onerror = () => {
                    console.log('主机名对应的 ICO 文件不存在:', icoUrl);
                };
                img.src = icoUrl;
            }
        },

			dataReorder(jsonList = []) {
			    // 重排显示顺序
			    const sortList = [
			        'typeHeader',   // typeHeader将头部导航栏放至第一
			        'typeJ',        // typeJ将接受隐私条款(弹窗)放至倒数第四
			        'typeQ',        // typeQ将输入口令(弹窗)放至倒数第三
			        'typeTalk',     // typeTalk将客服聊天窗口(弹窗)放至倒数第二
			        'typeFooter'    // typeFooter将尾部导航栏放至末尾
			    ];
			    for (let type of sortList) {
			        let index = jsonList.findIndex(v => (v.edd || v.type) === type);
			        if (index > -1) {
			            if (type === 'typeHeader') {
			                jsonList.unshift(JSON.parse(JSON.stringify(jsonList[ index ])));
			                jsonList.splice(index + 1, 1);
			            } else {
			                jsonList.push(JSON.parse(JSON.stringify(jsonList[ index ])));
			                jsonList.splice(index, 1);
			            }
			        }
			    }
			    return jsonList;
			},
			loadDataError() {
			    this.$loading('', false);
			    this.$message('数据错误');
			},
			loadDataSuccess(phamula = {}) {
				// this.xitoList.splice(3, 1);
				// this.xitoList.splice(5, 1);
				// this.xitoList.splice(6, 1);
                this.phamula = phamula;
				if (this.xitoList.length) {
				    // 开启socket
				    this.openScrollSocket();
				    // 开启特效
				    this.$nextTick(() => {
				    	// 特效在DOM生成之后开启
				    	this.effectInit();
				    	// 获取每个模块的位置
				    	this.blockPosition();
				    });
				}
                this.$loading('', false);
				console.log(JSON.parse(JSON.stringify(this.phamula)), JSON.parse(JSON.stringify(this.xitoList)))
			},
			effectInit() {
            	const offset = 300,
            		  scroll_top_duration = 700,
            		  $back_to_top = $('.go-back-top');
            	$(window).scroll(function(){
            		( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible');
            	});
            	// 返回最顶部
            	$back_to_top.on('click', function(event){
            		event.preventDefault();
            		$('body,html').animate({ scrollTop: 0 }, scroll_top_duration);
            	});
            	this.scrollReveal.reveal('.scroll-reveal', {
            		// 动画的时长
            		duration: 1000,
            		// 延迟时间
            		delay: 500,
            		// 动画开始的位置，'bottom', 'left', 'top', 'right'
            		origin: 'bottom',
            		// 回滚的时候是否再次触发动画
            		reset: false,
            		// 在移动端是否使用动画
            		mobile: false,
            		// 滚动的距离，单位可以用%，rem等
            		distance: '300px',
            		// 其他可用的动画效果
            		opacity: 1,
            		easing: 'linear',
            		scale: 1,
            	});
            },
            blockPosition() {
            	const div = document.querySelector('.home-content');
                const children = div.querySelectorAll('.scroll-reveal');
            	this.blockList = Array.from(children).map(v => {
            		let index = v.getAttribute('index');
            		let type = v.getAttribute('type');
            		let id = v.getAttribute('id');
            		let result = this.xitoList.find(p => p.id === id);
            		let object_id = result.object_id_list || [];
            		let height = v.offsetHeight;
            		let top = v.offsetTop;
            		return {
            			top,
            			type,
            			height,
            			object_id
            		};
            	})
            },
            browserScroll(event) {
                if (this.scrollSocket.getConnected()) {
                    const height = document.querySelector('.home-content').offsetHeight;
                    const top = window.scrollY + Math.floor(window.innerHeight / 2);
                    const length = this.blockList.length;
                    if (length) {
                        let index = length - 1;
                        for (let i = 0; i < length; i++) {
                        	let sTop = this.blockList[i].top;
                        	let eTop = this.blockList[i].top + this.blockList[i].height;
                        	if (sTop <= top && top < eTop) {
                        		index = i;
                        		break;
                        	}
                        }
                        const result = this.blockList[index];
                        let uuid = this.$uuid;
                        let name = result.type;
                        let url = window.location.href;
                        let sorcllTop = window.scrollY;
                        let object_id = result.object_id;
                        let time = this.$time.now.timestamp;
                        let action = '/realtime/webBrowsingCollection';
                        let percen = Math.round(window.scrollY / (height - window.innerHeight) * 10000) / 100 + '%';
                        this.scrollSocket.emit('communication', {
                        	url,
                        	uuid,
                        	time,
                        	name,
                        	index,
                        	action,
                        	percen,
                        	sorcllTop,
                        	object_id
                        });
                    }
                }
            },
            openScrollSocket() {
				if (this.isIframe === false) {
					this.scrollSocket = socket({
						global: this,
						config: {
							debug: false,
					        connection: this.api + '?use_type=webBrowsingCollection'
						},
						events: {
							'error': function(error) {
								console.error(error);
								// this.$message(error);
							}
						}
					    /*
						events: {
							// 正在连接
							'connect': function(data) {},
					        // 重新连接
							'reconnect': function(data) {},
					        // 断开连接
							'disconnect': function(data) {},
							// socket连接成功
							'socketConnectioned': function(data) {},
							// 正在连接
							'connect': console.log,
					        // 重新连接
							'reconnect': console.log,
					        // 断开连接
							'disconnect': console.log,
							// socket连接成功
							'socketConnectioned': console.log,
						}
					    */
					});
					window.onscroll = throttle(this.browserScroll, 200);
				}
            },
            closeScrollSocket() {
                if (this.scrollSocket && this.scrollSocket.close) {
                    this.scrollSocket.close();
                }
            }
        },
        filters: {
            setModuleClass(type = '') {
                // 如果是弹窗
                if (['typeJ', 'typeQ', 'typeTalk'].indexOf(type) > -1) {
                    return '';
                }
                return 'scroll-reveal';
            }
        },
		computed: {
            api() {
                // return 'http://192.168.0.101:23334';
                //return 'http://rtservice.xitohere.com';
                return 'https://rtservice.xitohere.com';
                return process.env.NODE_ENV === 'development' ? 'http://192.168.0.106:23334' : 'http://rtservice.xitohere.com';
            },
			isIframe() {
				return 'iframe' in this.$route.query;
			},
            componentConfig() {
            	const config = {};
            	Object.keys(component).forEach(componentName => {
            		let key = componentName.replace(/\-/g, '');
            		let value = component[componentName];
            		config[key] = value;
            	});
            	return config;
            }
        },
		beforeDestroy() {
            this.closeScrollSocket();
        }
	}
</script>

<style scoped lang="less">
	.home{
        .home-content{
            // position: relative;
        }
        .go-back-top{
        	display: inline-block;
        	position: fixed;
        	z-index: 10;
        	cursor: pointer;
        	overflow: hidden;
        	text-indent: 100%;
        	white-space: nowrap;
        	visibility: hidden;
        	opacity: 0;
        	box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
        	transition: opacity .3s 0s, visibility 0s 0s;
        	background: rgba(0, 0, 0, 0.5) url(../../assets/image/cd-top-arrow.svg) no-repeat center 50%;
        }
        .cd-is-visible{
        	visibility: visible;
        	opacity: 1;
        }
        .go-back-top:hover{
            opacity: 1;
        	background-color: #080808;
        }
    }
    @media screen and (max-width: 1024px){
    	.go-back-top{
    		height: 40px;
    		width: 40px;
    		right: 20px;
    		bottom: 20px;
    		background-size: 30px;
    	}
    }
    @media screen and (min-width: 1024px){
    	.go-back-top{
    		height: 50px;
    		width: 50px;
    		right: 30px;
    		bottom: 30px;
    		background-size: 40px;
    	}
    }
</style>
